export enum MythicPlusScoreType {
    FortifiedTyrannical,
    WarWithin,
}
